// src/components/PinisiKata/PinisiWinnerScreen.js
import React, { useEffect, useRef } from 'react';
import styles from './PinisiKata.module.css';
import { ACTIONS } from './PinisiKataGame';

// Fungsi helper untuk membuat efek confetti
const createConfetti = (container) => {
    if (!container) return;
    const colors = ['#ff6f00', '#4caf50', '#2196f3', '#9c27b0', '#f44336'];
    for (let i = 0; i < 50; i++) {
        const confetti = document.createElement('div');
        confetti.className = styles.confetti; // Gunakan kelas dari CSS Module
        confetti.style.left = `${Math.random() * 100}%`;
        confetti.style.background = colors[Math.floor(Math.random() * colors.length)];
        confetti.style.animationDelay = `${Math.random() * 3}s`;
        container.appendChild(confetti);
        // Hapus elemen setelah animasi selesai agar tidak menumpuk
        setTimeout(() => confetti.remove(), 3000);
    }
};

/**
 * Komponen PinisiWinnerScreen menampilkan layar pemenang di akhir permainan.
 * @param {object} props
 * @param {object} props.state - Objek state lengkap dari reducer.
 * @param {function} props.dispatch - Fungsi dispatch untuk mengirim aksi.
 */
function PinisiWinnerScreen({ state, dispatch }) {
    const { player1Score, player2Score } = state;
    const containerRef = useRef(null);

    // Menentukan pemenang
    let winnerText, winnerShip;
    if (player1Score > player2Score) {
        winnerText = '🏆 TIM MERAH MENANG! 🏆';
        winnerShip = '⛵';
    } else if (player2Score > player1Score) {
        winnerText = '🏆 TIM BIRU MENANG! 🏆';
        winnerShip = '⛵';
    } else {
        winnerText = '🤝 HASIL SERI! 🤝';
        winnerShip = '🤝';
    }
    
    // Memicu efek confetti saat komponen pertama kali ditampilkan
    useEffect(() => {
        createConfetti(containerRef.current);
    }, []);

    const handleRestart = () => {
        dispatch({ type: ACTIONS.RESTART_GAME });
    };

    return (
        <div ref={containerRef} className={`${styles.screen} ${styles.winnerScreen} ${styles.active}`}>
            <h2 className={styles.winnerTitle}>{winnerText}</h2>
            
            <div className={styles.winnerShip}>{winnerShip}</div>
            
            <div className={styles.finalScores}>
                <div className={styles.finalScoreRow}>
                    <span style={{ color: '#d32f2f' }}>🔴 TIM MERAH:</span>
                    <span>{player1Score}</span>
                </div>
                <div className={styles.finalScoreRow}>
                    <span style={{ color: '#1976d2' }}>🔵 TIM BIRU:</span>
                    <span>{player2Score}</span>
                </div>
            </div>

            <button className={styles.restartButton} onClick={handleRestart}>
                MAIN LAGI
            </button>
        </div>
    );
}

export default PinisiWinnerScreen;